import { gql } from '@apollo/client';
import { CreatorFields } from '../../../utils/apollo/fragments';

export const IncidentFieldsFragment = gql`
  fragment IncidentFields on Incident {
    id
    name
    description
    type {
      id
      name
    }
    creator {
      ...CreatorFields
    }
    start
    end
    createdAt
  }
  ${CreatorFields}
`;
